import {Component, Input, OnInit, ViewChild } from '@angular/core';
import { Network } from '@ionic-native/network/ngx';
import { ModalController, ToastController, LoadingController, AlertController, IonRadioGroup  } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { SendPage } from '../send/send.page';
import { ApiService } from '../../services/api/api.service';
import { PrintService } from '../../services/print/print.service';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import {GlobalVariables} from '../../common/global-variables';
import { StorageService } from "../../services/storage/storage.service";

@Component({
  selector: 'app-vend',
  templateUrl: './vend.page.html',
  styleUrls: ['./vend.page.scss'],
})
export class VendPage implements OnInit {

  @Input() payload: any;
  
  @ViewChild('radioGroup', { static: false }) radioGroup: IonRadioGroup
   //Get value on ionChange on IonRadioGroup
   selectedRadioGroup:any;
   //Get value on ionSelect on IonRadio item
   selectedRadioItem:any;

  vendorSettings: any;
  deviceInfo: any;
  storageSettings:any;
  internalVendor: boolean;
  info: any;
  loaderToShow: any;
  isOffline: boolean;
  vendForm: any;
  success = false;
  transaction: any;



  constructor(private modalController: ModalController, private network: Network,
              public api: ApiService, public loadingController: LoadingController,
              public toastController: ToastController, private ga: GoogleAnalytics,
              public authService: AuthenticationService, public alertController: AlertController,
              private formBuilder: FormBuilder, public printService: PrintService,
              private globals: GlobalVariables,private storageService:StorageService) {
    this.checkNetwork();

    this.network.onChange().subscribe(status => {
      if (this.network.type === 'none') {
        this.isOffline = true;
        this.presentToast('You\'re now offline', 'danger');
      } else {
        this.isOffline = false;
        this.presentToast('You\'re now connected via: ' + this.network.type, 'success');
      }
    });

    this.vendForm = this.formBuilder.group({
        amount: ['', [Validators.required, Validators.min(0)]]
      });
  }

  ngOnInit() {
    this.deviceInfo = this.globals.deviceInfo;
    this.vendorSettings = this.globals.vendorSettings;
    this.storageSettings = this.storageService.getObject('vendor-settings');
    this.internalVendor = this.globals.userInfo.internalVendor;
    // construct payload object
    this.payload.Amount = 0;
    this.selectedRadioGroup = 0;
    this.ga.trackView('vend')
        .then(() => {})
        .catch(e => console.log(e));

  }

  radioGroupChange(event) {
    console.log("radioGroupChange",event.detail.value);
    this.selectedRadioGroup = event.detail;
  }

  async vendToken() {
    this.authService.startSessionTimer(true);

    const warningMessage = 'You\'re about to vend a new token for ' + this.vendorSettings.currency +
                    ' ' + this.vendForm.value.amount + ' on this meter: '
                    + this.payload.MeterNumber + '.<br/><br/> <strong>Are you sure ?</strong>';

    const alert = await this.alertController.create({
      header: 'Confirm Create Token !',
      message: warningMessage,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            // console.log('Confirm Cancel: blah');
            this.presentToast('Please change vend amount or go back to change Meter Number !', 'warning');
          }
        },
        {
          text: 'Vend Token',
          cssClass: 'warning',
          handler: () => {
            this.payload.Amount = this.vendForm.value.amount;
            if (this.payload.Amount > 0) {
              this.showLoader('Creating Utility Token...');
              // debugger
                 let printerValue = this.storageSettings.__zone_symbol__value.printerInterface;
                 if(printerValue == 'DESKTOP'){
                 //this.payload.OutputFormat = 0;
                  this.payload.OutputFormat = 6;
                  }else{
                   this.payload.OutputFormat = 3;
                  }
                  //For testing 
                 // this.payload.IsRealTransaction = 0
                  //set payment method
                  this.payload.vendingMethod = this.selectedRadioGroup.value;
                  //set vending method 
                 // this.payload.vendingMethod = this.vendForm.value.amount
              // this.ga.trackEvent('vend', 'vend-token', this.payload.MeterNumber, this.payload.Amount);
              const endpoint = this.globals.deviceInfo.remoteServer + 'vend';
              this.api.postApiEndpoint(endpoint, this.payload).subscribe((resp) => {
                this.success = resp.ok;
                if (resp.ok) {
                  this.info = resp.data;
                  this.transaction = resp;
                  this.hideLoader();
                  this.success = true;
                } else {
                  this.ga.trackException(resp.msg, false);
                  this.info = resp.data;
                  this.hideLoader();
                  this.presentToast(resp.msg, 'danger');
                }
              }, err => {
                  this.success = false;
                  this.hideLoader();
                  this.presentToast(err.toString(), 'danger');
              });
            } else {
              this.info = 'Cannot vend a token, please enter a valid amount';
              this.presentToast('Cannot vend a token, please enter a valid amount', 'danger');
            }
          }
        }
      ]
    });

    await alert.present();

  }

  async printToken(trans) {
    this.printService.print(trans.data);
  }

  async sendToken(trans) {
    this.authService.startSessionTimer(true);
    this.payload.PaySeqID = null;
    this.payload.MessageTrace = trans.msg;
    // Open the vend page
    const modal = await this.modalController.create({
      component: SendPage,
      componentProps: {
        transaction: trans,
        payload: this.payload
      }
    });

    modal.onDidDismiss().then((dataReturned) => {
      console.log('Vend Sent Data: ', dataReturned);
    });

    return await modal.present();

  }

  quickVendAmount(amnt) {
    // console.log(amnt);
    this.vendForm.value.amount = amnt;
  }

  checkNetwork() {
    if (this.network.type === 'none') {
        this.isOffline = true;
        // alert('You\'re now offline');
      } else {
        this.isOffline = false;
        // alert('You\'re now connected via: ' + this.network.type);
      }
  }

  showLoader(displayMessage) {
    this.loaderToShow = this.loadingController.create({
      message: displayMessage
    }).then((res) => {
      res.present();

      res.onDidDismiss().then((dis) => {
        // console.log('Loading dismissed!');
      });
    });
    // this.hideLoader();
  }

  hideLoader() {
    setTimeout(() => {
      this.loadingController.dismiss();
    }, 500);
  }

  async closeModal() {
    const onClosedData = {
        ok: this.success,
        msg: this.info
    };
    await this.modalController.dismiss(onClosedData);
  }

  async presentToast(msg, color) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      position: 'bottom',
      color
    });
    toast.present();
  }

}
